module.exports = __webpack_public_path__ + "static/media/icon-time.9233bd1e.svg";